import { getFetcherHeader } from "../../modules/ajio-fetch/utils";
import isNode from "../../modules/ajio-util/isNode";
import fetcher from '../../modules/ajio-fetch';
const endpoints = require('../../modules/ajio-util/endpoints');
import {
    readCookie,
    createCookieForHours,
    createCookie
} from '../../components/common/Cookie';
import { fetchGetJSONResHandler, fetchGetJSONReqOpts } from '../../modules/ajio-util/jsonUtils';
import { setErrorObject } from "./HTTPError";
import { getRushAvailabilityCookieExpireTimeInHours } from '../../refresh/selectors/featureFlagsSelector';


// constants for actionTypes
const RUSH_ADDRESS_BAR_OPEN = 'RUSH_ADDRESS_BAR_OPEN';
const RUSH_ADDRESS_BAR_CLOSED = 'RUSH_ADDRESS_BAR_CLOSED';

export const RUSH_DELIVERY_TYPE_REQUEST = "RUSH_DELIVERY_TYPE_REQUEST";
export const RUSH_DELIVERY_TYPE_SUCCESS = "RUSH_DELIVERY_TYPE_SUCCESS";
export const RUSH_DELIVERY_TYPE_FAILURE = "RUSH_DELIVERY_TYPE_FAILURE";


function roundToSix(value = '') {
  if (value === '' || value === null || value === undefined) return '';

  const num = Number(value);
  if (!Number.isFinite(num)) return '';

  return Number(num.toFixed(6));
}

//actions

export const rushAddressBarOpen = () => ({
    type: RUSH_ADDRESS_BAR_OPEN
});

export const rushAddressBarClose = () => ({
    type: RUSH_ADDRESS_BAR_CLOSED
});

export const fetchDeliveryTypeRequest = () => ({
  type: RUSH_DELIVERY_TYPE_REQUEST
});

export const fetchDeliveryTypeSuccess = (pdpDeliveryResponse) => ({
  type: RUSH_DELIVERY_TYPE_SUCCESS,
  payload: pdpDeliveryResponse,
});

export const fetchDeliveryTypeFailure = (error) => ({
  type: RUSH_DELIVERY_TYPE_FAILURE,
  payload: error,
});


//rush availability api call
export const chechRushAvailability = (pincode, userAddress) => {          //todo check wether this is working or not
  if(pincode){
    return async function (dispatch, getState) {
        const state = getState();
        let rushAvailable = JSON.parse(readCookie('RushAvail'));

        if ((rushAvailable && rushAvailable.pincode === pincode)) {
            return Promise.resolve();
        }

        let apiEndPoint = `/api/home/deliveryType/availability/${pincode}`;
        let { location={}, locationLatLong={}, lat='', long='' } = userAddress;             //todo check if this is correct
        let latitude = location?.lat || locationLatLong?.lat || lat;
        let longitude = location?.long || locationLatLong?.long || long;
        if(latitude && longitude){
          apiEndPoint = `${apiEndPoint}/${parseFloat(latitude).toFixed(4)}/${parseFloat(longitude).toFixed(4)}`;
        }
        return fetcher(
            apiEndPoint,
            fetchGetJSONReqOpts({
              method: 'GET',
              headers: { 'content-type': 'application/json' }
            })
          )
          .then(fetchGetJSONResHandler)
          .then(response => {
            const status = response?.status?.statusCode;
            const rushAvailabilityCookieExpireTimeInHours = getRushAvailabilityCookieExpireTimeInHours(state);
            if ((status === 0 || status === 200) && typeof response?.data?.rushDelivery === 'boolean') {
              createCookieForHours('RushAvail', JSON.stringify({ 
                pincode: pincode, 
                rushDelivery: response?.data?.rushDelivery 
              }), rushAvailabilityCookieExpireTimeInHours);
              
              if (latitude && longitude) {
                createCookieForHours('RushLocationCoords', JSON.stringify({ lat: roundToSix(latitude), long: roundToSix(longitude)}), 24);
              }
              return response;
            } else {                                                //if API fails or data is corrupted like rush is null
              createCookieForHours('RushAvail', JSON.stringify({ 
                pincode: pincode, 
                rushDelivery: true 
              }), rushAvailabilityCookieExpireTimeInHours);

              if (latitude && longitude) {
                createCookieForHours('RushLocationCoords', JSON.stringify({ lat: roundToSix(latitude), long: roundToSix(longitude) }), 24);
              }
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
        });
    };
  }
};


export const rushPDPDeliveryTypeAPICall = (pincode, userAddress, optionCode, customerUuid, isServer) => {   //this API tells which PDP sizes have rush delivery available
  if(pincode && optionCode){
  return async function (dispatch) {
      dispatch({ type: RUSH_DELIVERY_TYPE_REQUEST });

      // if (false) {       //todo add PDP product delivery condition here
      //     return Promise.resolve();
      // }

      const parseUserAddress = (addr) => {
        if (!addr) return {};
          return typeof addr === 'object' ? addr : JSON.parse(addr || '{}');
      };

      let { lat = '', long = '' } = parseUserAddress(userAddress);   //todo check if this is correct
      let apiEndPoint;

      if (lat && long) {
        if(isServer){
          apiEndPoint = `${endpoints.get('productDeliveryTypeRush')}?pincode=${pincode}&optionCode=${optionCode}&latitude=${lat}&longitude=${long}`;
        }
        else{
          apiEndPoint = `/api/p/deliveryTypePDPCall/${pincode}/${optionCode}/${lat.toFixed(4)}/${long.toFixed(4)}`;
        }
      } else {
          if(isServer){
            apiEndPoint = `${endpoints.get('productDeliveryTypeRush')}?pincode=${pincode}&optionCode=${optionCode}`;
          }
          else{
            apiEndPoint = `/api/p/deliveryTypePDPCall/${pincode}/${optionCode}`;
          }
      }

      return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'GET',
            headers: { 'X-TENANT-ID': 'AJIO',
              'REQUEST-ID':'pdp_delivery_type',                   //OPTIONAL HEADER
              ...(customerUuid && { 'CUSTOMER-UID': customerUuid })
             }
          })
        )
        .then(fetchGetJSONResHandler)
        .then(response => {
          const status = response?.status?.statusCode;
          
          if ((status === 0 || status === 200) && response?.skus?.length>0) {
            let responseArray = [...response.skus];
            dispatch({ 
              type: RUSH_DELIVERY_TYPE_SUCCESS, 
              payload: responseArray
            });
            
            return responseArray;
          } else if(status === 1 ){
            const errorObj = {
              errorType: 'info',
              message: 'Oops! something went wrong, Please try again'
            };
            dispatch(setErrorObject(errorObj));
            const timeout = setTimeout(() => {
              dispatch(setErrorObject({}));
              clearTimeout(timeout);
            }, 5000);
            dispatch({ 
              type: RUSH_DELIVERY_TYPE_FAILURE, 
              payload: error.message
            });
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          dispatch({ 
            type: RUSH_DELIVERY_TYPE_FAILURE, 
            payload: error.message
          });
      });
      
  };
  }
};